import { render, staticRenderFns } from "./tab-details.vue?vue&type=template&id=bf6dab72&scoped=true"
import script from "./tab-details.vue?vue&type=script&lang=js"
export * from "./tab-details.vue?vue&type=script&lang=js"
import style0 from "./tab-details.vue?vue&type=style&index=0&id=bf6dab72&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6dab72",
  null
  
)

export default component.exports